module.exports = "/images/icon_32_duration.png?e740a18cdcae4f3696b379c388d40797";